// import React, { memo, TextareaHTMLAttributes, useEffect, useRef } from 'react';
//
// import classNames from 'classnames';
//
// import cls from './ModalTitle.module.css';
// import { useAppSelector } from '../../../store';
//
// interface IModalInputProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
//     isError: boolean;
//     autoFocus?: boolean;
//     onChangeHandler: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
//     classes?: string;
//     triggerAnimationError?: boolean;
//     setTriggerAnimationError?: React.Dispatch<React.SetStateAction<boolean>>;
//     errorClassName?: string;
// }
//
// export const ModalTitle: React.FC<IModalInputProps> = memo(
//     ({
//         autoFocus,
//         onChangeHandler,
//         classes,
//         isError,
//         setTriggerAnimationError,
//         triggerAnimationError,
//         errorClassName,
//         ...rest
//     }) => {
//         const inputRef = useRef<HTMLTextAreaElement>(null);
//         const { modalMode } = useAppSelector((store) => store.taskBoardReducer);
//
//         const adjustHeight = () => {
//             if (inputRef.current) {
//                 inputRef.current.style.height = '20px';
//                 inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
//             }
//         };
//
//         useEffect(() => {
//             if (autoFocus) {
//                 inputRef.current?.focus();
//             }
//             adjustHeight();
//         }, [autoFocus, modalMode]);
//
//         useEffect(() => {
//             let timeout = null;
//             if (triggerAnimationError || isError) {
//                 timeout = setTimeout(() => {
//                     setTriggerAnimationError?.(false);
//                 }, 500);
//             }
//
//             return () => clearTimeout(timeout);
//         }, [triggerAnimationError, isError, setTriggerAnimationError]);
//
//         return (
//             <textarea
//                 ref={inputRef}
//                 {...rest}
//                 className={classNames(
//                     cls.Input,
//                     classes,
//                     isError && cls.Error,
//                     triggerAnimationError && cls.WiggleError,
//                     errorClassName && errorClassName
//                 )}
//                 autoFocus={modalMode === 'addNewTask'}
//                 onChange={(e) => {
//                     onChangeHandler(e);
//                     adjustHeight();
//                 }}
//                 onInput={adjustHeight}
//                 maxLength={512}
//                 style={{ overflow: 'hidden', resize: 'none' }}
//             />
//         );
//     }
// );

import React, {
    memo,
    TextareaHTMLAttributes,
    useEffect,
    useRef,
    forwardRef,
    useImperativeHandle,
} from 'react';

import classNames from 'classnames';

import cls from './ModalTitle.module.css';
import { useAppSelector } from '../../../store';

interface IModalInputProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    isError: boolean;
    autoFocus?: boolean;
    onChangeHandler: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    classes?: string;
    triggerAnimationError?: boolean;
    setTriggerAnimationError?: React.Dispatch<React.SetStateAction<boolean>>;
    errorClassName?: string;
}

export const ModalTitle = memo(
    forwardRef<HTMLTextAreaElement, IModalInputProps>(
        (
            {
                autoFocus,
                onChangeHandler,
                classes,
                isError,
                setTriggerAnimationError,
                triggerAnimationError,
                errorClassName,
                ...rest
            },
            ref
        ) => {
            const inputRef = useRef<HTMLTextAreaElement>(null);
            const { modalMode } = useAppSelector((store) => store.taskBoardReducer);

            // Позволяем родителю получить реальный DOM-элемент textarea
            useImperativeHandle(ref, () => inputRef.current as HTMLTextAreaElement);

            const adjustHeight = () => {
                if (inputRef.current) {
                    inputRef.current.style.height = '20px';
                    inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
                }
            };

            useEffect(() => {
                if (autoFocus) {
                    inputRef.current?.focus();
                }
                adjustHeight();
            }, [autoFocus, modalMode]);

            useEffect(() => {
                let timeout: any = null;
                if (triggerAnimationError || isError) {
                    timeout = setTimeout(() => {
                        setTriggerAnimationError?.(false);
                    }, 500);
                }
                return () => clearTimeout(timeout);
            }, [triggerAnimationError, isError, setTriggerAnimationError]);

            return (
                <textarea
                    ref={inputRef}
                    {...rest}
                    className={classNames(
                        cls.Input,
                        classes,
                        isError && cls.Error,
                        triggerAnimationError && cls.WiggleError,
                        errorClassName && errorClassName
                    )}
                    autoFocus={modalMode === 'addNewTask'}
                    onChange={(e) => {
                        onChangeHandler(e);
                        adjustHeight();
                    }}
                    onInput={adjustHeight}
                    maxLength={512}
                    style={{ overflow: 'hidden', resize: 'none' }}
                />
            );
        }
    )
);
